import { Component, OnDestroy } from '@angular/core';
import { BreadcrumbService } from './breadcrumb.service';
import { Subscription } from 'rxjs/Subscription';
import { MenuItem } from 'primeng/primeng';
import { Globals } from './globals/Globals';
import { RouterConst } from './globals/RoutersConst';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './app.breadcrumb.component.html',
})
export class AppBreadcrumbComponent implements OnDestroy {
  subscription: Subscription;

  items: MenuItem[];

  constructor(
    private router: Router,
    private cookiesService: CookieService,
    private http: HttpClient,
    private breadcrumbService: BreadcrumbService,
  ) {
    this.subscription = breadcrumbService.itemsHandler.subscribe(response => {
      this.items = response;
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  logout() {
    this.http.get(Globals.SERVER_ADDR + '/logoutMe').subscribe((data: any) => {
      console.log('this is logout', data);
    });
    Globals.TOKEN = undefined;
    localStorage.clear();
    this.cookiesService.deleteAll();
    this.router.navigate(['/' + RouterConst.LOGIN]);
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/app.breadcrumb.component.ts